<template>
  <div id="forget-password" class="text-center container">
    <h5>パスワードのリセット</h5>
    <div v-if="message" class="mt-3 text-danger">{{ message }}</div>
    <div class="mt-3">
      <b-form-input type="email" placeholder="メールアドレス" v-model="username"></b-form-input>
    </div>
    <b-button variant="primary" class="btn btn-lg btn-primary btn-block mt-4"
      @click="sendMail" :disabled="username === ''">
      メールを送信
    </b-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'forget-password',
  data() {
    return {
      username: '',
      message: '',
    };
  },
  methods: {
    ...mapActions([
      'storeIsLoading',
    ]),
    sendMail() {
      const auth = firebase.auth();
      this.storeIsLoading(true);
      auth.sendPasswordResetEmail(this.username)
        .then(() => {
          // Email sent.
          alert('メールを送信しました。メールをご確認ください。');
          this.$router.push('/');
        }).catch((error) => {
          // An error happened.
          if (error.code === 'auth/user-not-found') {
            alert('登録されていないメールアドレスです。');
          } else if (error.code === 'auth/invalid-email') {
            alert('メールアドレスを入力してください。');
          } else {
            alert('パスワードのリセットに失敗しました。しばらくしてから再度やり直してください。');
          }
        })
        .finally(() => {
          this.storeIsLoading(false);
        });
    },
  },
};
</script>

<style scoped>
#forget-password{
  max-width: 330px;
  margin-top: 120px;
  margin-bottom: 150px;
}

</style>



// WEBPACK FOOTER //
// src/views/ForgetPassword.vue